"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUNDLE_MAX_IMAGE_BYTES = exports.BUNDLE_MAX_IMAGE_EDGE = exports.DESIGN_BUNDLE_SIZES = exports.DESIGN_BUNDLE_TARGETS = void 0;
exports.bundleSizesFor = bundleSizesFor;
const enums_1 = require("./enums");
exports.DESIGN_BUNDLE_TARGETS = ['both', 'canva', 'figma'];
/**
 * The artboard sizes we emit, current as of 2026-08. Note 4:5 portrait — not square — is the
 * primary feed size on Instagram and Facebook now, so it leads the list and is the default.
 */
exports.DESIGN_BUNDLE_SIZES = {
    portrait: {
        id: 'portrait-1080x1350',
        label: 'Portrait 4:5',
        width: 1080,
        height: 1350,
        usage: 'Primary Instagram + Facebook feed size — takes the most vertical space in-feed.',
    },
    square: {
        id: 'square-1080x1080',
        label: 'Square 1:1',
        width: 1080,
        height: 1080,
        usage: 'Safe everywhere; the best single choice for X.',
    },
    story: {
        id: 'story-1080x1920',
        label: 'Story 9:16',
        width: 1080,
        height: 1920,
        usage: 'Instagram/Facebook Stories and Reels covers.',
    },
    linkedinFeed: {
        id: 'linkedin-1200x1200',
        label: 'LinkedIn feed',
        width: 1200,
        height: 1200,
        usage: 'LinkedIn feed image.',
    },
    linkedinLink: {
        id: 'linkedin-link-1200x627',
        label: 'LinkedIn link preview',
        width: 1200,
        height: 627,
        usage: 'The card shown when a LinkedIn post carries a link.',
    },
    landscape: {
        id: 'landscape-1200x675',
        label: 'Landscape 16:9',
        width: 1200,
        height: 675,
        usage: 'X landscape, blog headers, video thumbnails.',
    },
};
/**
 * Which sizes to emit for a destination. Kept deliberately short — a bundle with twenty artboards
 * is worse than one with three, because the user has to work out which to open.
 */
function bundleSizesFor(channel, platform) {
    const s = exports.DESIGN_BUNDLE_SIZES;
    if (channel !== enums_1.ContentChannel.SOCIAL)
        return [s.landscape, s.square];
    switch (platform) {
        case enums_1.SocialPlatform.INSTAGRAM:
        case enums_1.SocialPlatform.FACEBOOK:
        case enums_1.SocialPlatform.THREADS:
            return [s.portrait, s.square, s.story];
        case enums_1.SocialPlatform.LINKEDIN:
            return [s.linkedinFeed, s.linkedinLink];
        case enums_1.SocialPlatform.X:
            return [s.square, s.landscape];
        case enums_1.SocialPlatform.YOUTUBE_SHORTS:
            return [s.story];
        default:
            return [s.portrait, s.square];
    }
}
/**
 * Figma silently downscales any raster whose longest side exceeds this, so there is no point
 * shipping bigger — and a 3x "retina" export would just be resampled on import.
 */
exports.BUNDLE_MAX_IMAGE_EDGE = 4096;
/** Canva rejects uploads above 25 MB, which is the tighter of the two ceilings. */
exports.BUNDLE_MAX_IMAGE_BYTES = 25 * 1024 * 1024;
//# sourceMappingURL=design-bundle.js.map